import React from "react"
import ShowBreakdown from "./breakdown"
import Logo from "../components/images/logo-2.png"

function Homepage() {

  const [value, setValue] = React.useState("")
  const [tax, setTax] = React.useState("")
  const [saving, setSaving] = React.useState("")
  const [expense, setExpense] = React.useState("")
  const [investment, setInvestment] = React.useState("")
  const [show, setShow] = React.useState(false)

  function handleClick() {
    var amount = Number(value)

    setTax(amount * 0.15)
    setSaving(amount * 0.30)
    setInvestment(amount * 0.20)
    setExpense(amount * 0.35)
    setShow(true)

  }

  return (
    <div className="homepage">
      
      <div className="row">
        <div className="column">

          <h1>The Creative Finance</h1>
          <h4>Financial Tracking Made Easy</h4>
          <br />
          <p>The Creative Finance is a web app that helps to organize and manage your money. It is challenging and tempting to spend money on things you probably don't need. That is when The Creative Financial comes in handy. It guides you to spend money on valuable investment funds now that will help you later. <br /> <br /> Below you can enter your monthly net income and it will track down where you need to spend your money the most and stop you from over spending.</p> <br />
        
          <a className="btn btn-primary" href="#GetStarted">Get Started →</a>
          <br /> <br />
            
        </div>
        <div className="column">
          <img src={Logo} alt="logo" />
        </div>
      </div>

      <div className="tracker" id="GetStarted">
        <h3>Break Down Your Expenses</h3>
        <p>Enter your net earnings for the month here and it will automatically guide you to spend your money the right way into investments, savings, expenses, taxes, and many more! </p> <br />

        <div className="input-group mb-3" style={{width: "35%"}}>
          <div className="input-group-prepend">
            <span className="input-group-text">$</span>
          </div>
          <input
            type="number"
            className="form-control"
            onChange={(event) => setValue(event.target.value)}
            placeholder="Enter Amount Here"
          />
          <div className="input-group-append">
            <button 
              className="btn btn-outline-primary calc"
              type="button"
              onClick={handleClick}
            >
              Calculate
            </button>
          </div>
        </div>

        <div style={show ? {display: "block"} : {display: "none"}}>

          <ShowBreakdown
            tax={(Math.round(tax * 100) / 100).toFixed(2)}
            investment={(Math.round(investment * 100) / 100).toFixed(2)}
            saving={(Math.round(saving * 100) / 100).toFixed(2)}
            expense={(Math.round(expense * 100) / 100).toFixed(2)}
          />
          <br />
          <h4>Challenge:</h4>
          <p>It is really tempting and easy to exceed the expenses limit and spend money on things that might not be too valuable. Therefore, here is a challenge that will stop you from over spending.</p>

          <p><strong>Spend less than ${(Math.round(((Number(value)) * 0.30) * 100) / 100).toFixed(2)} and either put the excessive amount to your savings or investments. </strong></p>

        </div>

      </div>

    </div>
  )
}

export default Homepage
